import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BaseModalActions from 'components/Modals/BaseModalActions'
import { List } from 'ui'
import { sortByTranslation } from 'services/Utilities'
import { setSortBy, setVisibleColumn, toggleDisplayArchive } from 'store/actions/tables'
import { closeModal } from 'store/actions/modals'

import { t } from 'translations'

const TableOptionsModal = ({ tableName }) => {
  const dispatch = useDispatch()
  const { [tableName]: options } = useSelector(state => state.tables)

  const { header, overwriteSortField, additionalSortFields = [] } = options

  const mainSortFields = overwriteSortField || header.filter(header => header.isSortable)

  const sortFields = [...additionalSortFields, ...mainSortFields].sort((a, b) => sortByTranslation(a.label, b.label))

  const toggleVisibility = h => setVisibleColumn(tableName, { ...options.visibleColumn, [h]: !options.visibleColumn[h] })

  // Sorts the header based on the label value (translated and without diacritics)
  const sortedHeader = header.concat().sort((a, b) => sortByTranslation(a.label, b.label))

  return (
    <BaseModalActions>
      {/* More options / Tools */}
      {options.canBeArchived || options.sync ? (
        <List className="mb-2">
          <List.Item className="pb-0">
            <h6>{t('components.table.TOOLS')}</h6>
          </List.Item>
          {options.canBeArchived && !options.archived ? (
            <ListActionItem key={`dropdown-more-archived`} label={'components.table.LOAD_ARCHIVED'} onClick={() => toggleDisplayArchive(tableName, true)} />
          ) : null}
          {options.canBeArchived && options.archived ? (
            <ListActionItem key={`dropdown-more-archived`} label={'components.table.HIDE_ARCHIVED'} onClick={() => toggleDisplayArchive(tableName)} />
          ) : null}
          {options.sync ? (
            <ListActionItem
              key={`dropdown-more-sync`}
              label={'components.table.SYNC'}
              onClick={() => {
                dispatch(closeModal())
                options.sync()
              }}
            />
          ) : null}
        </List>
      ) : null}

      {/* Section for which column to see */}
      {sortedHeader?.filter(({ notRemovable }) => !notRemovable)?.length ? (
        <List className="pb-2">
          <List.Item className="pb-0">
            <h6>{t('administration.SEE_COLUMNS')}</h6>
          </List.Item>
          {sortedHeader.map(h =>
            !h.notRemovable ? (
              <ListActionItem key={`dropdown-see-${h.key}`} label={h.label} checked={options.visibleColumn[h.key]} onClick={() => toggleVisibility(h.key)} />
            ) : null
          )}
        </List>
      ) : null}

      {/* Section for sorting */}
      {sortFields.length ? (
        <List className="pb-2">
          <List.Item className="pb-0">
            <h6>{t('administration.SORT_BY')}</h6>
          </List.Item>
          {sortFields.map(h => (
            <ListActionItem
              key={`dropdown-sort-${h.key}`}
              label={h.label}
              icon={h.sortIcon}
              onClick={() => {
                setSortBy(tableName, h.key, h.inverseSort)
                dispatch(closeModal())
              }}
              checked={options.sortBy?.includes(h.key)}
              up={options.sortBy?.includes('-')}
            />
          ))}
        </List>
      ) : null}
    </BaseModalActions>
  )
}

export default TableOptionsModal

const ListActionItem = ({ checked, disabled, icon, label, id, onClick, up }) => (
  <button
    id={id}
    key={id}
    type="button"
    className={`list-group-item list-group-item-action ${disabled ? ' disabled' : ''}`}
    onClick={() => {
      if (typeof onClick === 'function') onClick()
    }}
  >
    {checked && !icon ? <i className="far fa-check dropdown-check" /> : null}
    {checked && icon ? <i className={`far fa-sort-${icon}-${up ? 'up' : 'down'} dropdown-check`} /> : null}
    {t(label)}
  </button>
)
